import { WordDetail } from '@/components/words/word-detail';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/words/$wordId')({
  component: WordDetailPage,
});

function WordDetailPage() {
  const { wordId } = Route.useParams();
  return <WordDetail wordId={wordId} />;
}
